<template>
  <PlayerLayout>
    <div class="d-flex flex-column flex-md-row mx-12 my-6" slot="main">
      <v-sheet v-if="story" class="d-flex flex-column flex-1" color="grey-lighten-4" rounded>
        <div class="d-flex flex-column">
          <div class="cal-sans-regular font-size-26">{{ story.title || story.name }}</div>
          <div class="cal-sans-regular font-size-16 my-2">{{ story.description }}</div>
          
          <v-btn v-if="authUser" @click="riff" color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-guitar-pick-outline</v-icon>
            Riff
          </v-btn>

          <v-btn v-if="authUser && story.creator && authUser.uid === story.creator.id" @click="edit" color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-pencil</v-icon>
            Edit Story
          </v-btn>
        </div>
      </v-sheet>
      <v-sheet v-else-if="loading" class="d-flex flex-column flex-1" color="grey-lighten-4" rounded>
        <v-progress-linear indeterminate></v-progress-linear>
      </v-sheet>
    </div>
  </PlayerLayout>
</template>

<script>
import { getDoc, doc } from 'firebase/firestore';
import { db } from '@/firebase/init';
import PlayerLayout from '@/layouts/Player.vue';

export default {
  name: 'StoryPlayer',
  components: {
    PlayerLayout,
  },
  data() {
    return {
      story_id: null,
      loading: false,
      story: null,
    };
  },
  methods: {
    loadStory() {
      this.loading = true;
      this.story_id = this.$route.params.id;
      if (this.story_id) {
        const storyRef = doc(db, 'stories', this.story_id);
        getDoc(storyRef)
          .then((doc) => {
            if (doc.exists()) {
              let storyData = doc.data();
              storyData.id = doc.id;
              this.story = storyData;
            } else {
              console.error('No such document!');
              this.story = null;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.error('Error getting document:', error);
            this.loading = false;
            this.story = null;
          });
      } else {
        this.loading = false;
      }
    },
    async riff() {
      await this.$creator.riff('story', this.story.id, this.profile);
    },
    edit() {
      this.$creator.edit('story', this.story.id);
    }
  },
  created() {
    this.loadStory();
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.loadStory();
        }
      },
    },
  },
};
</script>
